// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"168":"positioning","769":"layouts"}[chunkId] || chunkId) + "." + {"168":"e27fec3d","769":"95ab8d0e","924":"7e1c85dc"}[chunkId] + ".js";
};